import React, { useState, useEffect } from "react";
import "../Style/newssec.css";
import axios from "axios";

function NewsSec() {
  const [news, setNews] = useState([]);

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    axios
      .get("https://nland.onrender.com/")
      .then((res) => {
        const data = res.data;

        console.log("res", data);
        res && setNews([...data]);
        console.log("news", news);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);
  return (
    <div className="newssec">
      <div className="ns_top">
        Latest News / Twitter / Facebook / How To Advertose
      </div>
      <div className="ns_mid">
        {loading ? (
          <h2>Loading...</h2>
        ) : (
          news?.map((res, index) => {
            let title = res.title;
            let url = encodeURIComponent(res.url);
            console.log(url);
            return (
              <a className="ns_mid-news" key={index} href={"/open/" + url}>
                <div dangerouslySetInnerHTML={{ __html: title && title }} />
              </a>
            );
          })
        )}
      </div>
      <div className="ns_bottom">
        <a href="/news/1">(1)</a>
        <a href="/news/2">(2)</a>
        <a href="/news/3">(3)</a>
        <a href="/news/4">(4)</a>
        <a href="/news/5">(5)</a>
        <a href="/news/6">(6)</a>
        <a href="/news/7">(7)</a>
        <a href="/news/8">(8)</a>
        <a href="/news/9">(9)</a>
        <a href="/news/10">(10)</a>
        <a href="/news/11">(11)</a>
      </div>
    </div>
  );
}

export default NewsSec;
